module.exports = __webpack_public_path__ + "media/customizations/bridgelandlife/logo-ab2500144df73580b999c46aa40d31c2.png";